export const DOCUMENTS_COMPARE_MODAL_COLUMNS = [
  {
    name: '',
    prop: 'type',
    resizeable: false,
    draggable: false,
    minWidth: 80,
    maxWidth: 80,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'documentIconTemplate',
  },
  {
    name: 'Created on',
    prop: 'createdAt',
    resizeable: false,
    draggable: false,
    minWidth: 100,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'dateTimeTemplate',
  },
  {
    name: 'Created by',
    prop: 'createdBy',
    resizeable: false,
    draggable: false,
    minWidth: 100,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'titlecaseTemplate',
  },
  {
    name: 'Language',
    prop: 'languageLabel',
    resizeable: false,
    draggable: false,
    minWidth: 100,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'titlecaseTemplate',
  },
  {
    name: 'File Format',
    prop: 'fileFormat',
    resizeable: false,
    draggable: false,
    minWidth: 100,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'titlecaseTemplate',
  },
  {
    name: 'Approved',
    prop: 'approvedAt',
    resizeable: false,
    draggable: false,
    minWidth: 100,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'dateTimeTemplate',
  },
  {
    name: 'Approved by',
    prop: 'approvedBy',
    resizeable: false,
    draggable: false,
    minWidth: 100,
    canAutoResize: true,
    flexGrow: 1,
    cellTemplate: 'titlecaseTemplate',
  },
];
